import { Stack, Typography } from '@mui/material'

type Props = {
  earlyWithdraw: number
  bonaship: number
  inflation: number
  bankSavings: number
  cash: number
  months: number
  intPerAnn: number
  slug: string
  className?: string
}

export const GraphSummary = ({
  earlyWithdraw,
  bonaship,
  // inflation,
  bankSavings,
  cash,
  months,
  intPerAnn,
  slug,
  className = '',
}: Props) => {
  const isSavingsChildren = slug === 'buducnost-mojich-deti'
  // const isSavingsRetirement = slug === 'zabezpecenie-financii-na-dochodok'
  const isSavingsBeatInflation = slug === 'sporte-a-porazte-inflaciu'

  const totalMonths = Math.max(0, Math.round((months ?? 0) * 12) + 1)
  const years = Math.floor(totalMonths / 12)
  // const remainingMonths = totalMonths % 12

  let yearsTxt = ''

  if (totalMonths === 0) {
    yearsTxt = 'Začiatok'
  } else if (years === 0) {
    yearsTxt = '0 rokov'
  } else if (years === 1) {
    yearsTxt = '1 rok'
  } else {
    yearsTxt = `${Math.floor(years / 12)} rokov`
  }

  return (
    <Stack
      className={`absolute w-[200px] gap-1.5 px-2 py-2.5 bg-zBlack200 rounded-2d ${className}`}>
      <Stack className="gap-1.5">
        <Stack className="flex-row justify-between items-center">
          <Stack className="flex-row items-center gap-1">
            <Stack
              className={`w-2.5 h-0.5 ${isSavingsBeatInflation ? 'bg-[#45f559]' : 'bg-zYellow500'} rounded-sm`}
            />
            <Typography className="text-xs font-medium text-zWhite200 mr-2">
              Bonaship
            </Typography>
          </Stack>
          <Typography
            className={`text-xs font-black ${isSavingsBeatInflation ? 'text-zWhite200' : 'text-zYellow500'} tabular-nums`}>
            {`${Math.round(bonaship || earlyWithdraw).toLocaleString('sk-SK')} €`}
          </Typography>
        </Stack>

        {(isSavingsChildren || isSavingsBeatInflation) && (
          <Stack className="flex-row justify-between items-center">
            <Stack className="flex-row items-center gap-1">
              <Stack
                className={`w-2.5 h-0.5 ${isSavingsBeatInflation ? 'bg-[#ff5c5b]' : 'bg-[#F4F4FF]'} rounded-sm`}
              />
              <Typography className="text-xs font-medium text-zWhite200 mr-2">
                Sporenie v banke
              </Typography>
            </Stack>
            <Typography className="text-xs font-black text-[#F4F4FF] tabular-nums">
              {`${Math.round(bankSavings).toLocaleString('sk-SK')} €`}
            </Typography>
          </Stack>
        )}

        <Stack className="flex-row justify-between items-center">
          <Stack className="flex-row items-center gap-1">
            <Stack
              className={`w-2.5 h-0.5 ${isSavingsBeatInflation ? 'bg-[#ff8c8c]' : 'bg-[#898a8e]'} rounded-sm`}
            />
            <Typography className="text-xs font-medium text-zWhite200 mr-2">
              Vaše vklady
            </Typography>
          </Stack>
          <Typography
            className={`text-xs font-black ${isSavingsBeatInflation ? 'text-zWhite200' : 'text-[#898a8e]'} tabular-nums`}>
            {`${Math.round(cash).toLocaleString('sk-SK')} €`}
          </Typography>
        </Stack>
      </Stack>

      {isSavingsBeatInflation && (
        <Stack className="flex-row justify-between items-center pt-1.5 border-t border-zGrey300">
          <Stack className="flex-row items-center gap-1">
            <Stack className="flex-row w-2.5 justify-between items-center">
              <Stack className="w-[3px] h-0.5 bg-[#F4F4FF] rounded-sm" />
              <Stack className="w-[3px] h-0.5 bg-[#F4F4FF] rounded-sm" />
              <Stack className="w-[3px] h-0.5 bg-[#F4F4FF] rounded-sm" />
            </Stack>
            <Typography className="text-xs font-medium text-zWhite200 mr-2">
              Priemerna inflácia
            </Typography>
          </Stack>
          <Typography className="text-xs font-black text-[#F4F4FF] tabular-nums">
            4 %
          </Typography>
        </Stack>
      )}

      <Stack className="flex-row justify-between pt-1.5 border-t border-zGrey300">
        <Typography className="text-xs font-black text-zWhite200">
          {yearsTxt}
        </Typography>
        <Typography className="text-xs font-medium text-zGrey400">{`${intPerAnn * 1000 * 0.1} % p.a.`}</Typography>
      </Stack>
    </Stack>
  )
}
